import { render } from "./local-transfer.vue?vue&type=template&id=71c26885"
import script from "./local-transfer.vue?vue&type=script&lang=js"
export * from "./local-transfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__